import React, { Component } from 'react'
import * as R from 'ramda'
import HoverInfo from '../../UniformComponents/HoverInfo'

import './styles/input.scss'

class Input extends Component {
    constructor(props) {
        super(props)
        this.inputRef = React.createRef()

        this.state = {
            hasEmptyError: false,
            hasFormatError: false,
        }
    }

    componentDidMount() {
        const { register, name, path } = this.props
        if (typeof register === 'function') {
            register(name, this.validate, path)
        }
    }

    componentWillUnmount() {
        const { unregister, name, path } = this.props
        if (typeof unregister === 'function') {
            unregister(name, path)
        }
    }

    handleKeyPress(e) {
        const { blurOnEnter } = this.props
        if (e.target.type === 'number' && e.keyCode === 69) {
            e.preventDefault()
        }

        if (e.keyCode === 13) {
            if (blurOnEnter) {
                // prevents double blur when modal is opened on component blur
                this.inputRef.current.blur()
            } else {
                this.onBlur(e)
            }
        }
    }

    validate = ({ value, name }, setState = false) => {
        const { isMandatory, validate, format } = this.props

        const hasValue = R.and(!R.isNil(value), !R.isEmpty(value))
        let isValid = !isMandatory || hasValue
        let hasValidFormat = true
        if (typeof validate === 'function') {
            isValid = isValid && validate({ value, name })
        }

        if (isValid && typeof format === 'function') {
            hasValidFormat = format(value)
        }

        // console.log(`validate ${name} (${value}) (${isMandatory}) -> ${isValid}`)

        if (setState) {
            this.setState({
                hasEmptyError: !isValid,
                hasFormatError: !hasValidFormat,
            })
        }

        return isValid && hasValidFormat
    }

    onChange = (e) => {
        const { name, onChange, isNumeric } = this.props
        const value = isNumeric
            ? this.toNumeric(e.target.value)
            : e.target.value

        this.validate({ value, name }, true)

        if (typeof onChange === 'function') {
            onChange({ value, name })
        }
    }

    toNumeric = (value) => (
        R.isEmpty(value) || R.isNil(value)
            ? undefined
            : Number(value)
    )

    onBlur = (e) => {
        const { name, onBlur, isNumeric } = this.props
        const value = isNumeric
            ? this.toNumeric(e.target.value)
            : e.target.value

        this.validate({ value, name }, true)

        if (typeof onBlur === 'function') {
            onBlur({ value, name })
        }
    }

    emitStep = () => {
        const { name, onBlur, isNumeric } = this.props
        const value = isNumeric
            ? this.toNumeric(this.inputRef.current.value)
            : this.inputRef.current.value

        this.validate({ value, name }, true)

        if (typeof onBlur === 'function') {
            onBlur({ value, name })
        }
    }

    increment = () => {
        this.inputRef.current.stepUp()
        this.emitStep()
    }

    decrement = () => {
        this.inputRef.current.stepDown()
        this.emitStep()
    };

    renderWarningIncon = () => {
        const { warningMsg, cssClass } = this.props
        if (!warningMsg) return null
        const warningClass = cssClass && cssClass.includes('answer-option') ? 'answer-option' : 'absolute'

        return (
            <HoverInfo
                cssClass={`warning-icon ${warningClass}`}
                desc={warningMsg}
                dir="right"
            >
                <i className="fa-regular fa-language warning" />
            </HoverInfo>
        )
    }

    render() {
        const {
            name,
            defaultValue,
            value,
            cssClass,
            placeholder,
            autocomplete,
            emptyError,
            formatError,
            type,
            label,
            id,
            onInvalid,
            pattern,
            required,
            style,
            disabled,
            min,
            max,
            tooltipTitle,
            tooltipText,
            tooltipLinkLabel,
            tooltipLink,
            warningMsg,
            onEdit,
            inputFieldDisabled,
            hideLabel,
            key,
            autoFocus,
        } = this.props
        const { hasFormatError, hasEmptyError } = this.state

        let componentClass = 'form-input'
        componentClass += cssClass ? ` ${cssClass}` : ''
        componentClass += disabled ? ' disabled' : ''

        return (
            <div className={componentClass} style={style}>
                <div className="label-container" style={{ display: hideLabel ? 'none' : 'flex' }}>
                    <label htmlFor={id} className={`${tooltipText ? 'extended' : ''}`}>
                        {label}
                    </label>
                    {tooltipText && (
                        <HoverInfo
                            cssClass="hover-info"
                            title={tooltipTitle}
                            desc={tooltipText}
                            linkText={tooltipLinkLabel}
                            href={tooltipLink}
                            dir="right"
                        >
                            <i className="info-icon fa-solid fa-circle-question" />
                        </HoverInfo>
                    )}
                </div>
                {!disabled ? (
                    <>
                        {this.renderWarningIncon()}
                        <input
                            ref={this.inputRef}
                            type={type || 'text'}
                            key={key}
                            name={name}
                            className={hasEmptyError || hasFormatError ? ' error' : ''}
                            onBlur={this.onBlur}
                            defaultValue={defaultValue}
                            placeholder={placeholder}
                            autoComplete={autocomplete ? 'on' : 'off'}
                            onKeyDown={(e) => this.handleKeyPress(e)}
                            value={value}
                            onChange={this.onChange}
                            onInvalid={onInvalid}
                            pattern={pattern}
                            required={required}
                            disabled={inputFieldDisabled}
                            min={min}
                            max={max}
                            onClick={(e) => e.stopPropagation()}
                            autoFocus={autoFocus}
                            style={{ ...(warningMsg ? { textIndent: '28px' } : {}) }}
                        />
                    </>
                ) : (
                    <React.Fragment>
                        <div className="disabled-text">
                            <span style={{marginRight: '8px' }}>{this.renderWarningIncon()}</span>
                            {defaultValue ?? value}
                        </div>
                        {typeof onEdit === 'function' && (
                            <i className="disabled-icon fa-light fa-edit" onClick={onEdit} />
                        )}
                    </React.Fragment>
                )}
                {((emptyError && hasEmptyError) || (formatError && hasFormatError)) && (
                    <i className="error-icon fa-regular fa-circle-exclamation" />
                )}
                {((emptyError && hasEmptyError) || (formatError && hasFormatError)) && (
                    <p className="error-msgs">{hasEmptyError ? emptyError : formatError}</p>
                )}
                {type === 'number' && (
                    <div className="num-icon">
                        <i className="up-icon fa-regular fa-chevron-up" onClick={this.increment} />
                        <i className="down-icon fa-regular fa-chevron-down" onClick={this.decrement} />
                    </div>
                )}
            </div>
        )
    }
}

export default Input
